import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import request from '@tools/requests';
import {
  URL_USER_ORGANIZATION_TEAM,
  URL_USER_ORGANIZATION_TEAM_CHECK_EXISTS,
  URL_USER_ORGANIZATION_TEAM_INVITATION,
} from '@tools/routes/routes';

const useOrganizationStore = defineStore('organization', () => {
  const team = ref([]);
  const invitations = ref([]);
  const currentUserId = ref(null);
  const accountManager = ref(null);
  const emailsToInvite = ref([]);

  const validatedEmails = computed(() => emailsToInvite.value.map((user) => user.email));

  const addEmail = (email) => emailsToInvite.value.push({ email, hasError: false });

  const setEmailError = (index) => {
    const invitation = emailsToInvite.value[index];
    invitation.hasError = true;
    emailsToInvite.value.splice(index, 1, invitation);
  };

  const doesInvitationsHasError = () => emailsToInvite.value.some((email) => email.hasError);

  const removeEmail = (index) => emailsToInvite.value.splice(index, 1);
  const resetInvitations = () => emailsToInvite.value.splice(0);

  const isEmailAlreadyInvited = (email) => emailsToInvite.value.findIndex((invitedEmail) => invitedEmail.email === email) >= 0;

  const isInvitedUserAlreadyMember = (email) => new Promise((resolve, reject) => {
    request
      .get(`${URL_USER_ORGANIZATION_TEAM_CHECK_EXISTS}?email=${email}`)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((e) => {
        reject(e);
      });
  });

  const deleteUser = (userId, isInvited) => {
    const endpoint = isInvited ? URL_USER_ORGANIZATION_TEAM_INVITATION : URL_USER_ORGANIZATION_TEAM;

    return new Promise((resolve, reject) => {
      request
        .delete(`${endpoint}/${userId}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  const sendInvitations = () => new Promise((resolve, reject) => {
    request
      .post(`${URL_USER_ORGANIZATION_TEAM_INVITATION}`, { emails: validatedEmails.value })
      .then(({ data }) => {
        const json = JSON.parse(data);

        if (!team.value) {
          team.value = [];
        }

        json.users?.forEach((user) => {
          invitations.value.push(user);
        });

        resolve(data);
      })
      .catch((e) => {
        reject(e);
      });
  });

  return {
    team,
    invitations,
    currentUserId,
    accountManager,
    emailsToInvite,
    doesInvitationsHasError,
    addEmail,
    setEmailError,
    removeEmail,
    resetInvitations,
    isEmailAlreadyInvited,
    isInvitedUserAlreadyMember,
    deleteUser,
    sendInvitations,
  };
});

export default useOrganizationStore;
